import React from "react";
import { Box, Button, Flex, Image, Text } from "@chakra-ui/react";
import SVG from "react-inlinesvg";
import MyDashboardLinkageModal from "@/features/my-dashboard/components/linkage/MyDashboardLinkageModal";
import MyDashboardLinkageLoadingPage from "@/features/my-dashboard/components/linkage/MyDashboardLinkageLoadingPage";
import { SjLoadingSpinner } from "@/shared/components/SjLoadingSpinner";

interface MyDashboardBeforeLinkageProps {
  hasRequested: boolean;
  status?: "PENDING" | "PROGRESSING";
}

function MyDashboardBeforeLinkage({
  hasRequested,
  status,
}: MyDashboardBeforeLinkageProps) {
  return (
    <Box position={"relative"} minH={"600px"}>
      <Image src={"/images/my-dashboard-blur.png"} alt={"blur-dashboard"} />
      <Flex
        flexDirection={"column"}
        gap={"16px"}
        alignItems={"center"}
        position={"absolute"}
        top={"50%"}
        left={"50%"}
        transform={"translate(-50%, -50%)"}
      >
        {hasRequested ? <ReviewOngoing status={status} /> : <BeforeLinkage />}
      </Flex>
    </Box>
  );
}

export default MyDashboardBeforeLinkage;

const BeforeLinkage = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <>
      <Flex flexDirection={"column"} gap={"12px"} alignItems={"center"}>
        <SVG
          src={"/icons-v1_1/upload-data-window.svg"}
          width={48}
          height={48}
          color={"#8F8F8C"}
        />
        <Box textAlign={"center"}>
          <Text textStyle={"body-lg-regular"}>
            자사 웹사이트 연동으로 데이터에 기반한 스마트 소싱을 시작하세요.
          </Text>
          <Text textStyle={"body-lg-regular"}>
            가장 많이 전시된 브랜드 순위와 브랜드에 최적화된 공급사를 매칭해
            드려요.
          </Text>
        </Box>
      </Flex>
      <Button
        padding={"8px 12px"}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        borderRadius={"4px"}
        background={"#1272EF"}
        boxShadow={"0 2px 4px 0 rgba(0, 0, 0, 0.10)"}
        color={"#FFFFFF"}
        onClick={() => setIsOpen(true)}
      >
        <Text textStyle={"body-md-bold"}>연동하기</Text>
      </Button>
      <MyDashboardLinkageModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};

interface ReviewOngoingProps {
  status?: "PENDING" | "PROGRESSING";
}

const ReviewOngoing = ({ status }: ReviewOngoingProps) => {
  const isPending = status === "PENDING";
  return (
    <Flex flexDirection={"column"} gap={"24px"} alignItems={"center"}>
      <SjLoadingSpinner />
      <Box textAlign={"center"}>
        <Text textStyle={"body-lg-regular"}>
          {isPending ? "웹사이트 연동에 필요한 정보를 " : "웹사이트"}
          <span
            style={{
              fontWeight: "bold",
            }}
          >
            {isPending ? "검수 중" : "연동 중"}
          </span>
          입니다.
        </Text>
        <Text textStyle={"body-lg-regular"}>
          {isPending
            ? "최대 1일이 소요됩니다."
            : "정확한 분석을 위해 약 7일 이상 소요될 수 있습니다."}
        </Text>
      </Box>
    </Flex>
  );
};
